import React from 'react';

/**
 * Reusable chart wrapper with title
 * @param {string} title - Chart card title
 * @param {React.ReactNode} children - Chart content
 * @param {string} className - Optional extra class
 */
const ChartCard = ({ title, children, className = '' }) => {
  return (
    <div className={`chart-card ${className}`}>
      {title && <div className="chart-card-title">{title}</div>}
      <div className="chart-card-body">
        {children}
      </div>
    </div>
  );
};

export default ChartCard;
